import React from "react";
import { Carousel, Col, Container, Row } from "react-bootstrap";
import Navigation from "../Shared/Navigation/Navigation";
import "./ProjectDetails.css";
import { BsGithub, RiExternalLinkLine } from "react-icons/all";
import dentaverse1 from "../../Images/dentaverse/dentaverse1.PNG";
import dentaverse2 from "../../Images/dentaverse/dentaverse2.PNG";
import dentaverse3 from "../../Images/dentaverse/dentaverse3.PNG";
import cameraworld1 from "../../Images/camera-world/cameraworld1.PNG";
import cameraworld2 from "../../Images/camera-world/cameraworld2.PNG";
import cameraworld3 from "../../Images/camera-world/cameraworld3.PNG";
import worldtour1 from "../../Images/world-tour/worldtour1.PNG";
import worldtour2 from "../../Images/world-tour/worldtour2.PNG";
import worldtour3 from "../../Images/world-tour/worldtour3.PNG";
import Footer from "../Shared/Footer/Footer";

const ProjectsDetails = () => {
  return (
    <div>
      <Navigation className="bg-transparent"></Navigation>
      <div
        className="text-white"
        style={{ backgroundColor: "#030303", textAlign: "justify" }}
      >
        <Container className="py-5">
          <h1 className="py-5 text-center">All of My Projects</h1>
          <Row
            xs={1}
            md={2}
            className="g-4 py-5 my-5 align-items-center justify-content-around project-detail "
          >
            <Col xs={12} md={4}>
              <Carousel fade>
                <Carousel.Item>
                  <img
                    className="d-block slider-image w-100"
                    src={cameraworld1}
                    alt="First slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block slider-image w-100"
                    src={cameraworld2}
                    alt="Second slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block slider-image w-100"
                    src={cameraworld3}
                    alt="Third slide"
                  />
                </Carousel.Item>
              </Carousel>
            </Col>
            <Col xs={12} md={6}>
              <h2>Camera-Wolds</h2>
              <p>
                On this website you will find different types of cameras and you
                can buy any camera of your choice with details description.
              </p>
              <h5>Features:</h5>
              <ul>
                <li>
                  <p>
                    Users can buy any camera and also can cancel their order.
                  </p>
                </li>
                <li>
                  <p>Users and post their review once they are logged in.</p>
                </li>
                <li>
                  <p>Users can watch other users review of the wesite</p>
                </li>
                <li>
                  <p> Admin also has power to cancel any order.</p>
                </li>
                <li>
                  <p>
                    Admin has the power to make new andmin and add any product.
                  </p>
                </li>
              </ul>
              <h5>Technology:</h5>
              <p>
                HTNL, CSS, Bootstrap, React, React-Router, React-Hook-Form,
                Node.js, Express.js, Mongo dB, Firebase, Heroku Website:
                Client-side:
                <br />
              </p>

              <a
                href="https://github.com/alim-shaon/camera-world-client"
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <BsGithub className="icon-style" />
                Code-Client-Side
              </a>
              <a
                href="https://github.com/alimshaon/
                camera-world-server"
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <BsGithub className="icon-style" />
                Code-Server-Side
              </a>
              <a
                href="https://camera-world-fy.web.app/ "
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <RiExternalLinkLine className="icon-style" />
                Live-Site
              </a>
            </Col>
          </Row>
          {/* world tour */}
          <Row
            xs={1}
            md={2}
            className="g-4 py-5 my-5 align-items-center justify-content-around project-detail "
          >
            <Col xs={12} md={4}>
              <Carousel fade>
                <Carousel.Item>
                  <img
                    className="d-block slider-image w-100"
                    src={worldtour1}
                    alt="First slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block slider-image w-100"
                    src={worldtour2}
                    alt="Second slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block slider-image w-100"
                    src={worldtour3}
                    alt="Third slide"
                  />
                </Carousel.Item>
              </Carousel>
            </Col>
            <Col xs={12} md={6}>
              <h2>World-Tour</h2>
              <p>
                It is a tourism website where users can select and cancel any
                tour package within their conveniently available package.
              </p>
              <h5>Features:</h5>
              <ul>
                <li>
                  <p>
                    Users can Choose and book any tour around the world they
                    wishes.
                  </p>
                </li>
                <li>
                  <p>
                    Users need to log in to book any tour and they can cancel
                    the tour.
                  </p>
                </li>
                <li>
                  <p> users can sign up using their goggle account.</p>
                </li>
                <li>
                  <p>Admin can change user’s tour status. </p>
                </li>
                <li>
                  <p>Admin also can add or remove any tour package. </p>
                </li>
              </ul>
              <h5>Technology:</h5>
              <p>
                HTNL, CSS, Bootstrap, React, React-Router, React-Hook-Form,
                Node.js, Express.js, Mongo dB, Firebase, Heroku Website:
                Client-side:
                <br />
              </p>

              <a
                href="https://github.com/alim-shaon/world-tour-client"
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <BsGithub className="icon-style" />
                Code-Client-Side
              </a>
              <a
                href="https://github.com/alim-shaon/worldtour-
                server"
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <BsGithub className="icon-style" />
                Code-Server-Side
              </a>
              <a
                href="https://world-tour-fy.web.app/"
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <RiExternalLinkLine className="icon-style" />
                Live-Site
              </a>
            </Col>
          </Row>

          {/* dentaverse */}
          <Row
            xs={1}
            md={2}
            className="g-4 py-5 my-5 align-items-center justify-content-around project-detail "
          >
            <Col xs={12} md={4}>
              <Carousel fade>
                <Carousel.Item>
                  <img
                    className="d-block slider-image w-100"
                    src={dentaverse1}
                    alt="First slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block slider-image w-100"
                    src={dentaverse2}
                    alt="Second slide"
                  />
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block slider-image w-100"
                    src={dentaverse3}
                    alt="Third slide"
                  />
                </Carousel.Item>
              </Carousel>
            </Col>
            <Col xs={12} md={6}>
              <h2>Dentaverse</h2>
              <p>
                This is a dental service booking website where you can book or
                cancel the dental service of your choice.
              </p>
              <h5>Features:</h5>
              <ul>
                <li>
                  <p>
                    Patient can login using their goggle account or any Gmail
                    account
                  </p>
                </li>
                <li>
                  <p>
                    Users can book any dental service they want from the
                    available services{" "}
                  </p>
                </li>
                <li>
                  <p> Users can also see the available doctors.</p>
                </li>
                <li>
                  <p>Users can cancel their appointment with the doctor</p>
                </li>
              </ul>
              <h5>Technology:</h5>
              <p>
                HTNL, CSS, Bootstrap, React, React-Router, React-Hook-Form,
                Node.js, Express.js, Mongo dB, Firebase, Heroku Website:
                Client-side:
                <br />
              </p>

              <a
                href="https://github.com/alim-shaon/dentaverse"
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <BsGithub className="icon-style" />
                Code
              </a>
              <a
                href="https://dentaverse-73.web.app/ "
                target="_blank"
                rel="noreferrer"
                className="icon-link"
              >
                <RiExternalLinkLine className="icon-style" />
                Live-Site
              </a>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer></Footer>
    </div>
  );
};

export default ProjectsDetails;
